import { useQuery, useMutation } from 'react-query'
import API from '.'
import { serializeQuery } from './utils'

const ENDPOINT = '/api/staff-benefit-claim'
const QUERY_KEY = 'staff-benefit-claim'

export const useGetStaffBenefitClaims = (query = {}, config = { refetchOnWindowFocus: false }) =>
  useQuery(
    [QUERY_KEY, 'claim-list', query],
    async () => (await API.get(serializeQuery(ENDPOINT, query))).data,
    config
  )

export const usePostClaimStaffBenefit = (config = {}) =>
  useMutation((newData) => API.post(ENDPOINT, newData), config)

export const usePatchReviewStaffBenefitClaim = (config = {}) =>
  useMutation((updatedData) => API.patch(`${ENDPOINT}`, updatedData), config)
